<template>
    <v-dialog :value="textDialog" @input="$emit('closeTextDialog')" width="500px">
        <v-card class="image-card">
            <v-card-title class="d-flex justify-center">
                <h4>{{text}}</h4>
            </v-card-title>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: "TextMessage",
    props:{
        textDialog:{
            type:Boolean
        },
        text:{
            type: String
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/FieldManagement/FieldWork/Data/TaskType/TextMessage.vue